import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogActionsComponent } from './dialog-actions.component';

@NgModule({
  declarations: [DialogActionsComponent],
  imports: [
    CommonModule
  ],
  exports: [DialogActionsComponent]
})
export class DialogActionsModule { }
